import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SyncoInviteExpiredIcon = (props: IconProps) => (
  <Icon w="230px" h="234px" viewBox="0 0 230 234" {...props} fill="none">
    <ellipse
      opacity="0.38"
      cx="114.922"
      cy="101.214"
      rx="96.8284"
      ry="96.881"
      fill="#D6D6D6"
    />
    <path
      d="M85.6277 202.606L82.715 202.15C82.0993 202.053 81.6658 201.494 81.7265 200.873L84.7403 169.948L93.5468 171.329L86.9591 201.694C86.8269 202.303 86.2428 202.703 85.6271 202.607L85.6277 202.606Z"
      fill="#282644"
    />
    <path
      d="M176.324 183.065L178.79 181.45C179.312 181.108 179.477 180.42 179.166 179.879L163.698 152.936L156.24 157.821L174.735 182.782C175.106 183.283 175.803 183.407 176.324 183.065L176.324 183.065Z"
      fill="#282644"
    />
    <path
      d="M102.705 61.4792C101.621 61.7127 100.553 61.0228 100.319 59.9385L98.6433 52.1515C98.4099 51.0672 99.0995 49.9986 100.183 49.7651C101.267 49.5316 102.335 50.2214 102.569 51.3058L104.245 59.0933C104.478 60.1776 103.789 61.2462 102.705 61.4797L102.705 61.4792Z"
      fill="#282644"
    />
    <path
      d="M104.444 46.7926L95.0787 48.8106C94.2839 48.9818 93.7784 49.7652 93.9495 50.5603L94.4143 52.72C94.5854 53.5151 95.3685 54.0209 96.1632 53.8496L105.529 51.8317C106.324 51.6605 106.829 50.8771 106.658 50.082L106.193 47.9222C106.022 47.1271 105.239 46.6214 104.444 46.7926Z"
      fill="#3395FF"
    />
    <path
      d="M72.7376 83.259C71.478 84.524 69.4321 84.528 68.1677 83.268L49.855 65.289C48.5906 64.0289 48.5867 61.9822 49.8463 60.7171C51.1059 59.4521 53.1518 59.4481 54.4162 60.7082L72.7284 78.6872C73.9928 79.9473 73.9967 81.9941 72.7371 83.2591L72.7376 83.259Z"
      fill="#282644"
    />
    <path
      d="M76.233 59.7757L49.593 87.3367L45.4146 83.2949C42.0087 79.9996 41.9176 74.5655 45.2116 71.1579L59.9235 55.9374C63.2175 52.5299 68.6492 52.4385 72.0552 55.7337L76.2335 59.7756L76.233 59.7757Z"
      fill="#3395FF"
    />
    <path
      d="M138.976 68.9877C140.644 69.6219 142.51 68.783 143.144 67.1139L152.437 43.1871C153.071 41.518 152.233 39.6511 150.565 39.0169C148.896 38.3827 147.03 39.2216 146.396 40.8907L137.103 64.8174C136.469 66.4866 137.307 68.3535 138.976 68.9877Z"
      fill="#282644"
    />
    <path
      d="M126.13 49.025L161.747 63.1723L163.892 57.768C165.641 53.3622 163.488 48.3722 159.085 46.6232L139.415 38.8104C135.011 37.0614 130.023 39.215 128.275 43.6208L126.129 49.0251L126.13 49.025Z"
      fill="#3395FF"
    />
    <path
      d="M129.005 183.679C163.664 176.211 185.711 142.048 178.249 107.374C170.786 72.7005 136.639 50.6454 101.98 58.113C67.3206 65.5806 45.2733 99.7431 52.7359 134.417C60.1985 169.091 94.3452 191.146 129.005 183.679Z"
      fill="#3395FF"
    />
    <path
      d="M126.592 172.471C155.056 166.338 173.162 138.283 167.033 109.808C160.905 81.3322 132.862 63.2198 104.399 69.3524C75.9355 75.4851 57.8295 103.54 63.9581 132.016C70.0866 160.491 98.129 178.604 126.592 172.471Z"
      fill="white"
    />
    <path
      d="M105.895 70.3461L103.446 70.8738C102.826 71.0074 102.431 71.6186 102.565 72.2388L104.548 81.4511C104.681 82.0714 105.292 82.4659 105.912 82.3323L108.361 81.8046C108.981 81.671 109.376 81.0599 109.242 80.4396L107.259 71.2274C107.126 70.6071 106.515 70.2126 105.895 70.3461Z"
      fill="#282644"
    />
    <path
      d="M64.9477 130.527L65.4751 132.977C65.6086 133.597 66.2194 133.992 66.8394 133.858L76.0478 131.874C76.6678 131.741 77.0623 131.129 76.9288 130.509L76.4014 128.059C76.2679 127.439 75.6571 127.044 75.037 127.178L65.8287 129.162C65.2086 129.295 64.8142 129.906 64.9477 130.527Z"
      fill="#282644"
    />
    <path
      d="M125.1 171.489L127.549 170.961C128.169 170.828 128.564 170.216 128.43 169.596L126.447 160.384C126.314 159.764 125.703 159.369 125.083 159.503L122.634 160.03C122.014 160.164 121.619 160.775 121.753 161.395L123.736 170.608C123.869 171.228 124.48 171.622 125.1 171.489Z"
      fill="#282644"
    />
    <path
      d="M166.047 111.308L165.52 108.857C165.387 108.237 164.776 107.843 164.156 107.976L154.947 109.96C154.327 110.094 153.933 110.705 154.066 111.325L154.594 113.776C154.727 114.396 155.338 114.79 155.958 114.657L165.166 112.673C165.786 112.539 166.181 111.928 166.047 111.308Z"
      fill="#282644"
    />
    <path
      d="M82.5167 83.4817L81.5519 84.3555C81.3426 84.545 81.3265 84.8685 81.516 85.0779L86.5998 90.6964C86.7893 90.9059 87.1126 90.9219 87.322 90.7324L88.2868 89.8586C88.4961 89.669 88.5122 89.3455 88.3227 89.1361L83.2389 83.5176C83.0494 83.3082 82.7261 83.2921 82.5167 83.4817Z"
      fill="#ADADAD"
    />
    <path
      d="M68.2353 104.99L67.8364 106.229C67.7498 106.498 67.8976 106.786 68.1663 106.873L75.3773 109.196C75.646 109.282 75.9341 109.134 76.0206 108.866L76.4195 107.626C76.5061 107.357 76.3584 107.069 76.0896 106.983L68.8787 104.66C68.6099 104.573 68.3218 104.721 68.2353 104.99Z"
      fill="#ADADAD"
    />
    <path
      d="M84.4677 148.115L85.3403 149.079C85.5298 149.289 85.5137 149.613 85.3046 149.802L79.6884 154.888C79.4787 155.078 79.1552 155.062 78.9658 154.853L78.0931 153.888C77.9036 153.678 77.9198 153.355 78.1289 153.165L83.7451 148.079C83.9547 147.89 84.2783 147.906 84.4677 148.115Z"
      fill="#ADADAD"
    />
    <path
      d="M99.5919 168.175L100.831 168.574C101.099 168.66 101.388 168.512 101.474 168.244L103.796 161.029C103.883 160.761 103.735 160.472 103.466 160.386L102.227 159.987C101.959 159.9 101.671 160.048 101.584 160.317L99.262 167.531C99.1754 167.8 99.3232 168.088 99.5919 168.175Z"
      fill="#ADADAD"
    />
    <path
      d="M148.469 158.31L149.433 157.436C149.643 157.246 149.659 156.923 149.469 156.714L144.386 151.095C144.196 150.886 143.873 150.87 143.663 151.059L142.699 151.933C142.489 152.123 142.473 152.446 142.663 152.655L147.746 158.274C147.936 158.483 148.259 158.499 148.469 158.31Z"
      fill="#ADADAD"
    />
    <path
      d="M154.566 134.165L154.965 132.927C155.051 132.657 155.339 132.509 155.609 132.596L162.819 134.919C163.088 135.005 163.236 135.294 163.149 135.563L162.751 136.801C162.664 137.071 162.376 137.218 162.107 137.131L154.896 134.809C154.627 134.723 154.479 134.434 154.566 134.165Z"
      fill="#ADADAD"
    />
    <path
      d="M152.893 87.9035L152.02 86.9383C151.83 86.7289 151.507 86.7128 151.298 86.9024L145.681 91.9887C145.472 92.1783 145.456 92.5017 145.645 92.7111L146.519 93.6764C146.708 93.8858 147.032 93.9019 147.241 93.7123L152.857 88.626C153.067 88.4364 153.083 88.1129 152.893 87.9035Z"
      fill="#ADADAD"
    />
    <path
      d="M131.394 73.6163L130.156 73.2173C129.887 73.1307 129.599 73.2785 129.512 73.5474L127.19 80.7616C127.104 81.0305 127.251 81.3186 127.52 81.4052L128.759 81.8042C129.028 81.8908 129.316 81.743 129.402 81.4741L131.724 74.2599C131.811 73.991 131.663 73.7029 131.394 73.6163Z"
      fill="#ADADAD"
    />
    <path
      d="M119.893 123.756C121.46 121.328 120.763 118.089 118.335 116.521C115.908 114.953 112.67 115.651 111.103 118.079C109.536 120.508 110.233 123.747 112.66 125.315C115.087 126.882 118.325 126.185 119.893 123.756Z"
      fill="#848484"
    />
    <path
      d="M68.0302 118.167L67.9915 118.944C67.9703 119.371 68.1537 119.73 68.4027 119.747L125.298 123.416L125.498 119.404L68.5188 117.409C68.2694 117.401 68.0509 117.741 68.0302 118.167Z"
      fill="#282644"
    />
    <path
      d="M129.997 154.452L128.533 155.049C128.21 155.18 127.84 155.028 127.703 154.706L109.613 112.377L113.745 110.694L130.352 153.627C130.478 153.953 130.32 154.321 129.997 154.452L129.997 154.452Z"
      fill="#282644"
    />
    <path
      d="M118.726 130.756L116.604 131.213L105.839 78.8035C105.812 78.6725 105.988 78.5237 106.232 78.4712L106.483 78.4171C106.727 78.3646 106.948 78.4276 106.978 78.5582L118.727 130.756L118.726 130.756Z"
      fill="#3395FF"
    />
    <path
      d="M119.541 120.714C119.427 118.482 117.525 116.764 115.294 116.879C113.062 116.993 111.346 118.896 111.46 121.128C111.574 123.361 113.476 125.078 115.708 124.964C117.939 124.849 119.656 122.947 119.541 120.714Z"
      fill="#ADADAD"
    />
  </Icon>
);

export default memo(SyncoInviteExpiredIcon);
